import React from "react";
import cn from "classnames";
import "./FocusBox.less";

interface FocusBoxProps {
    className?: string;
    children?: React.ReactNode;
}

const FocusBox: React.FC<FocusBoxProps> = ({ className, children }) => (
    <div className={cn("focus-box", className)}>
        <div className="content-outer">
            <section className="content-inner">{children}</section>
        </div>
    </div>
);

export default FocusBox;
